import { render, staticRenderFns } from "./DocumentUploadResultsModal.vue?vue&type=template&id=4f1d64f9&scoped=true"
import script from "./DocumentUploadResultsModal.vue?vue&type=script&lang=ts"
export * from "./DocumentUploadResultsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d64f9",
  null
  
)

export default component.exports